import { AirplaneIcon, BuildingsIcon } from "@phosphor-icons/react";
import { useIntl } from "react-intl";

import PageError from "@/components/Errors/PageError";

interface OfferNotAvailableErrorProps {
  variant: "flight" | "hotel";
}

export const OfferNotAvailableError = ({
  variant,
}: OfferNotAvailableErrorProps) => {
  const intl = useIntl();
  const Icon = variant === "flight" ? AirplaneIcon : BuildingsIcon;

  return (
    <PageError
      title={
        variant === "flight"
          ? intl.formatMessage({
              id: "flights.notAvailable.title",
              defaultMessage: "This flight offer is not available anymore",
            })
          : intl.formatMessage({
              id: "hotels.notAvailable.title",
              defaultMessage: "This hotel offer is not available anymore",
            })
      }
      subtitles={[
        variant === "flight"
          ? intl.formatMessage({
              id: "flights.notAvailable.description",
              defaultMessage:
                "Unfortunately, this flight offer is not available anymore. Please try again later or choose another flight.",
            })
          : intl.formatMessage({
              id: "hotels.notAvailable.description",
              defaultMessage:
                "Unfortunately, this hotel offer is not available anymore. Please try again later or choose another hotel.",
            }),
      ]}
      back={{
        text:
          variant === "flight"
            ? intl.formatMessage({
                id: "flights.notAvailable.button",
                defaultMessage: "Back to search",
              })
            : intl.formatMessage({
                id: "hotels.notAvailable.button",
                defaultMessage: "Back to search",
              }),
        options: {
          to: variant === "flight" ? "/flights/departure/list" : "/hotels/list",
        },
      }}
      icon={<Icon size={60} color="var(--color-text-interactive)" />}
    />
  );
};
